import { Alert, Button, Form, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useState } from "react";
import ExcelJS from "exceljs";
import { generateCode1 } from "./genCode";
import PTable from "../PTable/PTable";

const PForm = ({ messageApi }) => {
  const [form] = Form.useForm();
  const { Dragger } = Upload;

  const [loading, setLoading] = useState(false);
  const [upErr, setUpErr] = useState(null);
  const [file, setFile] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [pList, setPList] = useState([]);

  const parseFile = async ({ file }) => {
    try {
      setLoading(true);
      setFile(
        new File([file], file.name.split(".")[0], {
          type: file.type,
        })
      );

      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const buffer = reader.result;
        workbook.xlsx.load(buffer).then(async (wb) => {
          try {
            // access worksheet
            const worksheet = wb.getWorksheet("Tabelle1");
            console.log(worksheet);
            if (!worksheet) {
              throw new Error(
                "Expected worksheet(Tabelle1) not found in file!"
              );
            }

            // defining product list
            var products = [];

            // iterate over all rows
            worksheet.eachRow((row, rowNumber) => {
              // validate template
              const expectedHeaders = [
                "SKU",
                "Product Title",
                "Product Images",
                "Product Price",
                "Car Details",
                "OE-Teilennummern",
                "Vergleichnummer",
                "Motor",
                "Leistung",
                "Motorcode",
                "Notice Deposit",
                "Notice Header",
                "Notice List",
                "Notice Footer",
              ];
              const targetColLimit = expectedHeaders.length;
              const headerItemsText = expectedHeaders.join(", ");
              if (rowNumber === 1) {
                // check length
                if (row.actualCellCount !== targetColLimit) {
                  throw new Error(
                    `Please validate whether the listed columns are present in the excel file: ${headerItemsText}`
                  );
                }
                // check if any columms are missing
                var formattedHeaders = row.values.map((v) => v.trim());
                var missingHeaders = [];
                for (let i = 0; i < targetColLimit; i++) {
                  if (!formattedHeaders.includes(expectedHeaders[i])) {
                    missingHeaders.push(expectedHeaders[i]);
                  }
                }
                if (missingHeaders.length !== 0) {
                  throw new Error(
                    `The listed headers are missing: ${missingHeaders.join(
                      ", "
                    )}`
                  );
                }
                // validate column order
                for (let i = 0; i < targetColLimit; i++) {
                  if (formattedHeaders[i + 1] !== expectedHeaders[i]) {
                    throw new Error(
                      `Please check with the columns follows this ordering: ${headerItemsText}`
                    );
                  }
                }
              } else {
                // creating product object
                var product = {};
                console.log("Row =>", rowNumber);
                // iterate over each cell in a row
                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                  console.log(colNumber);
                  if (colNumber > targetColLimit) {
                    return;
                  }
                  // create object
                  switch (colNumber) {
                    case 1:
                      product.sku = cell.value
                        ? cell.value.toLocaleString()
                        : "";
                      break;
                    case 2:
                      product.name = cell.value
                        ? cell.value.toLocaleString()
                        : "";
                      break;
                    case 3:
                      if (typeof cell.value === "object") {
                        product.imgLinks = cell.value["text"]
                          ? cell.value.split(",").map((v) => v.trim())
                          : [];
                      } else {
                        product.imgLinks = cell.value
                          ? cell.value.split(",").map((v) => v.trim())
                          : [];
                      }
                      break;
                    case 4:
                      product.price = cell.value
                        ? cell.value.toLocaleString()
                        : null;
                      break;
                    case 5:
                      let cars = cell.value
                        ? cell.value.split("|").map((v) => v.trim())
                        : [];
                      product.cars = cars.map((c) => {
                        let cs = c.split("_");
                        return {
                          brand: cs[0],
                          models: cs[1].split("/").map((v) => v.trim()),
                        };
                      });
                      break;
                    case 6:
                      product.partNums = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 7:
                      product.compNums = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 8:
                      product.motors = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 9:
                      product.performance = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 10:
                      product.motorCodes = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 11:
                      product.nDeposit = cell.value ? cell.value : "";
                      break;
                    case 12:
                      product.nHeader = cell.value ? cell.value : "";
                      break;
                    case 13:
                      product.nList = cell.value
                        ? cell.value.split(",").map((v) => v.trim())
                        : [];
                      break;
                    case 14:
                      product.nFooter = cell.value ? cell.value : "";
                      break;
                    default:
                      break;
                  }
                });

                product = {
                  sku: product?.sku ? product.sku : "",
                  name: product?.name ? product.name : "",
                  imgLinks: product?.imgLinks ? product.imgLinks : [],
                  price: product.price ? product.price : "",
                  cars: product.cars ? product.cars : [],
                  partNums: product.partNums ? product.partNums : [],
                  compNums: product.compNums ? product.compNums : [],
                  motors: product.motors ? product.motors : [],
                  performance: product.performance ? product.performance : [],
                  motorCodes: product.motorCodes ? product.motorCodes : [],
                  nDeposit: product.nDeposit ? product.nDeposit : "",
                  nHeader: product.nHeader ? product.nHeader : "",
                  nList: product.nList ? product.nList : [],
                  nFooter: product.nFooter ? product.nFooter : "",
                };

                products.push(product);
              }
            });

            // reject if greater than 50 products
            // if (products.length > 50) {
            //   messageApi.open({
            //     type: "error",
            //     content: "Product upload limit exceeded!",
            //   });
            //   return;
            // }

            // generate ebay code for each product
            console.log("Initial prods => ", products);
            let idx = 0;
            let gp = products.map((p) => {
              idx += 1;
              try {
                let g = generateCode1(p);
                // if (idx % 4 === 0) {
                //   throw new Error();
                // }
                return { sno: idx, ebayCode: g, gErr: false, ...p };
              } catch (err) {
                console.log(err);
                return { sno: idx, ebayCode: "", gErr: true, ...p };
              }
            });
            // console.log("Final parsed product list => ", gp);
            setPList(gp);
            messageApi.open({
              type: "success",
              content: "File validation successful!",
            });
          } catch (err) {
            if (err?.message) {
              setUpErr(err.message);
            } else {
              setUpErr("Something went wrong!");
            }
            console.log(err.message);
            messageApi.open({
              type: "error",
              content: "File validation failed!",
            });
          }
        });
      };
    } catch (err) {
      setUpErr("Something went wrong!");
      console.log(err.message);
      messageApi.open({
        type: "error",
        content: "File validation failed!",
      });
    } finally {
      setLoading(false);
    }
  };

  const displayTable = () => {
    setSubmit(true);
  };

  const clearData = () => {
    setFile(null);
    setPList([]);
    setSubmit(false);
    setUpErr(null);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: upErr || !submit ? "column" : "row",
          justifyContent: "space-evenly",
          alignItems: upErr || !submit ? "center" : "flex-start",
          flexWrap: "wrap",
        }}
      >
        <div style={{ maxWidth: "800px", margin: "0 0 30px" }}>
          <Form
            name="productForm"
            form={form}
            layout="vertical"
            onFinish={displayTable}
          >
            <Form.Item
              name="products"
              label="Upload product list"
              required={true}
            >
              <Dragger
                accept=".xlsx"
                fileList={file ? [file] : []}
                maxCount={1}
                loading={loading}
                disabled={loading || file}
                beforeUpload={async (f) => {
                  setLoading(true);
                  await new Promise((r) => setTimeout(r, 3000));
                  if (
                    f.type !==
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  ) {
                    setUpErr(true);
                    return false;
                  }
                  setLoading(false);
                  return true;
                }}
                onRemove={(f) => {
                  setFile(null);
                  setPList([]);
                }}
                customRequest={parseFile}
                style={{ minWidth: "600px" }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Supports for a single file upload. (
                  <span
                    style={{
                      color: "#f00",
                      opacity: loading || file ? "0.3" : "1",
                    }}
                  >
                    Upload limit: 50 products
                  </span>
                  )
                </p>
              </Dragger>
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={submit || !file || upErr}
            >
              Generate
            </Button>
            <Button
              onClick={clearData}
              style={{ marginLeft: "10px" }}
              disabled={!file}
            >
              Clear
            </Button>
            <Button type="primary" style={{ marginLeft: "10px" }}>
              <a href="/data/template.xlsx" download="codegen-template.xlsx">
                Download file format
              </a>
            </Button>
          </Form>
        </div>

        {submit && (
          <>
            <PTable pList={pList} messageApi={messageApi}></PTable>
          </>
        )}

        {upErr && (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Alert
              type="error"
              message={upErr}
              showIcon
              // style={{ marginTop: "20px", width: "800px" }}
            ></Alert>
          </div>
        )}
      </div>
    </>
  );
};

export default PForm;
